// extracted by mini-css-extract-plugin
export default {"facetSearchContainer":"facetSearchContainer---yhyh0","facetSearch":"facetSearch---Khx9K","moreIcon":"moreIcon---uDL14"};